"use client";

import { GiftListSearchForm } from "@/components/gift-list-search/gift-list-search-form";
import { GiftListSearchResults } from "@/components/gift-list-search/gift-list-search-results";
import { GiftListSearchTour } from "@/components/gift-list-search/gift-list-search-tour";
import { PublicSearchHeader } from "@/components/gift-list-search/public-search-header";
import { usePublicGiftListSearch } from "@/components/gift-list-search/use-public-gift-list-search";
import { usePublicSearchMotion } from "@/components/gift-list-search/use-public-search-motion";

export function PublicGiftListSearch() {
  const controller = usePublicGiftListSearch();
  // Freezing the form stops duplicate submits and keeps the criteria on screen
  // matching the request in flight. `load-more` keeps the criteria, so it is out.
  const searchInFlight = controller.state.phase === "loading";
  // Reseeds the form when `expandSearch` remounts it: the fields may only show
  // criteria that are in effect.
  const queryInEffect =
    "criteria" in controller.state ? controller.state.criteria.query ?? "" : "";
  const {
    cancelProgrammaticScroll,
    scrollToPosition,
    setResultsElement,
    setScrollLocked,
  } = usePublicSearchMotion(
    controller.state.phase,
    controller.initialSearchVersion,
  );

  return (
    <div className="tb-editorial-body tb-public-search-page">
      <PublicSearchHeader onScrollLockChange={setScrollLocked} />
      <main className="min-w-0">
        <section id="top" className="tb-public-search-hero">
          <div className="tb-public-search-hero-inner">
            <p className="tb-public-search-eyebrow">Lista de Presentes · Para presentear</p>
            <h1 className="tb-public-search-title">
              Encontre a lista de quem você quer <em>presentear</em>.
            </h1>
            <p className="tb-public-search-intro">
              Sem o link direto? Busque pelo nome do casal, do anfitrião ou da lista, e refine por data ou cidade para chegar à lista certa.
            </p>
            <div className="tb-public-search-tour-slot">
              {controller.state.phase === "idle" && (
                <GiftListSearchTour
                  cancelProgrammaticScroll={cancelProgrammaticScroll}
                  scrollToPosition={scrollToPosition}
                />
              )}
            </div>
            <GiftListSearchForm
              key={controller.resetVersion}
              defaultQuery={queryInEffect}
              disabled={searchInFlight}
              onSubmit={controller.submit}
            />
          </div>
        </section>

        <div ref={setResultsElement} className="tb-public-search-results-shell">
          <GiftListSearchResults
            state={controller.state}
            onClear={controller.clear}
            onExpandSearch={controller.expandSearch}
            onLoadMore={controller.loadMore}
            onRetry={controller.retry}
          />
        </div>
      </main>
    </div>
  );
}
